import * as React from 'react';
import {RouteComponentProps} from 'react-router';
import {EmailSendResponse, ChecklistSummaries, ErrorResponse, Returnal} from '../../api/dtos/dtos';
import * as paths from '../../paths';
import {IdPageUrlParams} from '../../paths';
import furoApi from '../../api/FuroApi';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../../app/ApplicationContext';
import {setAppHeaderSubtitle} from "../../app/AppHeader";
import locales from "../../locales";
import {ErrorAlert} from "../../common/ErrorAlert";
import SendChecklistForm from "./SendChecklistForm";
import {showConfirm} from "../../utils/dialogs";
import ChecklistDetailsSummary from "./ChecklistDetailsSummary";
import SectionHeaderFormItem from "../../common/form-items/SectionHeaderFormItem";
import {idFromPathParams} from "../../utils/router-utils";
import {
  ChecklistFormMode, findAllNotIgnored,
  findChecklistByRentalItemId,
  findSendoutRecipients,
  hasChecklistCountMatch,
  isAccepted
} from "../dtos";
import RentalDetailsAlert from "./RentalDetailsAlert";
import {Button} from "antd";
import {showEmailSendResultModal} from "../../common/EmailSendResultModal";

interface State {
  returnal?: Returnal;
  summaries?: ChecklistSummaries;
  error?: ErrorResponse;
}

class SendRentalChecklistsPage extends React.Component<RouteComponentProps<IdPageUrlParams>, State> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  constructor(props: RouteComponentProps<{}>) {
    super(props);
    this.state = {};
  }

  public componentDidMount() {
    this.loadReturnal();
    this.loadChecklists();
  }

  public render() {
    const {returnal, error, summaries} = this.state;

    const accepted = isAccepted(summaries?.returnal);
    const checklistCountMatch = hasChecklistCountMatch(summaries?.returnal);
    const recipients = findSendoutRecipients(summaries?.returnal) ?? [];
    const initialContactIds: number[] = recipients.map((r) => r.contact.id);

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        {returnal &&
            <RentalDetailsAlert
                rental={returnal}
                rentalTitle={locales.return}
            />
        }
        {returnal && summaries &&
            <SendChecklistForm
                accepted={accepted}
                disabled={accepted || !checklistCountMatch}
                clientId={returnal.client!.id!}
                initialContactIds={initialContactIds}
                onFormCancel={this.onFormCancel}
                onFormSubmit={this.onReturnalFormSubmit}
            >
              {findAllNotIgnored(summaries.returnal)?.map((returnalChecklist) => {
                const rentalItem = returnalChecklist.rentalItem;
                const rentalItemID = rentalItem.id!;
                const rentalChecklist = findChecklistByRentalItemId(summaries.rental?.checklists, rentalItemID);
                const onEdit = () => this.onChecklistEdit(returnalChecklist.id!);

                return (
                  <div key={returnalChecklist.id!}>
                    <SectionHeaderFormItem title={
                      <>
                        {rentalItem.item.name}
                        {!accepted && <Button icon="edit"
                                              style={{marginLeft: 8}}
                                              onClick={onEdit}
                                              title={locales.edit}/>
                        }
                      </>
                    }/>
                    <div style={{width: "100%"}}>
                      <ChecklistDetailsSummary
                        rentalChecklist={rentalChecklist}
                        returnalChecklist={returnalChecklist}
                        mode={ChecklistFormMode.VIEW_RETURNAL}
                        style={{flex: 1, marginRight: 16}}
                      />
                    </div>
                  </div>
                );
              })}
            </SendChecklistForm>
        }
        <ErrorAlert style={{marginTop: '16px'}} error={error}/>
      </>
    );
  }

  private onFormCancel = () => {
    this.props.history.goBack();
  };

  private onReturnalFormSubmit = (contactIds: number[]) => {
    showConfirm(locales.checklist_send_confirm, () => this.sendReturnalChecklists(contactIds));
  };

  private sendReturnalChecklists = (recipientContactIds: number[]) => {
    const returnalID = idFromPathParams(this.props);
    const promise = furoApi.checklist.sendReturnalChecklists(returnalID, {recipientContactIds})
      .then(this.onSendResponse)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  }

  private onSendResponse = (response: EmailSendResponse) => {
    showEmailSendResultModal({
      title: locales.email_send_result_checklist,
      response,
      onSuccess: this.pop
    });
  };

  private pop = () => {
    this.props.history.goBack();
  }

  private loadReturnal = () => {
    const returnalID = idFromPathParams(this.props);
    const promise = furoApi.returns.get(returnalID)
      .then(this.onReturnalLoaded)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onReturnalLoaded = (response: Returnal) => {
    this.setState({returnal: response});
  };

  private loadChecklists = () => {
    const returnalID = idFromPathParams(this.props);
    const promise = furoApi.checklist.getReturnalChecklists(returnalID)
      .then(this.loadChecklistsSuccess)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private loadChecklistsSuccess = (response: ChecklistSummaries) => {
    this.setState({summaries: response});
    setAppHeaderSubtitle(this.props, locales.checklist_send_out);
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  }

  private onChecklistEdit = (id: number) => {
    this.props.history.push(paths.viewChecklistPath(id));
  }
}

export default SendRentalChecklistsPage;




// WEBPACK FOOTER //
// ./src/checklist/send/SendReturnalChecklistsPage.tsx